const pagesSlug = {
  dashboard: 'dashboard',
  newOrders: 'newOrders',
  kitting: 'productKitting',
  delivered: 'orderInDelivery',
  shipping: 'orderInShipping',
  thunderbird: 'thunderbird',
  users: 'users',
  settings: 'settings',
  askAi: 'askAi',
  schedules: 'schedules',
  logout: 'logout',
};

export default pagesSlug;
